/* eslint-disable import/prefer-default-export */
import { View } from '@src/utils/graph.helpers'
import type { Graph } from '@src/components/vis.js.network.vis/models'
import type { SearchResult } from '../../autocomplete.query'
import type { ObjectSummaryInfo } from '@src/endpoints/services/graphQueryMgr.service'
import type { InfoDetailsResult } from '@src/utils/resource.utils'

export interface ObjectInfo extends InfoDetailsResult {}

export interface ObjectItem extends ObjectSummaryInfo {
  account_name?: string
  object_type?: string
  actions_ut?: {
    READ?: string
    WRITE?: string
    ADMIN?: string
  }
  actions_str: string
  alerts?: string
}

// Reducer
export const defaultState = {
  users: 0,
  admin: 0,
  groups: 0,
  roles: 0,
  services: 0,
  policies: 0,
  alerts: 0,
  networks: 0,
  graph: {} as Graph,
  table: [] as SearchResult[],
  objectInfo: {
    Name: [] as string[]
  } as ObjectInfo,
  isPendingGraph: false,
  isPending: false,
  selectedGraphView: View.access,
  selectedTile: null as string | null
}

export type ObjectDetailsState = typeof defaultState
